export default "__VITE_ASSET__3vKgPxHO__"